// extracted by mini-css-extract-plugin
export default {"container":"MessageList_container__R-psm","list":"MessageList_list__yMdEw"};